<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11fCoD7/tc-custom/FC-9781528927437.jpg?1684604023651?1705687958507" alt="This image is the cover for the book Aussie Men Are the Pits"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Aussie Men Are the Pits
      </h1>
      <p class="bookDescription body article font2">
        <p>Trying to figure him out? Copping the wide-eyed stare across the room? Haven’t heard from Mr. Super-intense? Sick of never being asked for a simple coffee? Don’t worry. You’re not alone. And it’s not your fault. It’s his.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Esta Finch
      </h2>
      
      <p class="authorDescription body article">Esta Finch lived in an icy desert of a place, surrounded by miners and mountaineers. The men of the wild impressed her. The men of Australia, too heavy on the fortune and light on the masculinity, did not. The trepidation with which men goggled at the ladies about them but refused so much as a decent hello bothered her, particularly given how many exceptional ladies there are out there. Esta is no writer, but she is a traveller and purveyor of men and their relations with the fairer sex. The question she has is, can they rediscover themselves in the face of the female?</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?8a7be9d2